import { useEffect, useState } from 'react';
import DropDownSearch from '../../../../components/DropDownSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from '../../../../components/Modal';
import {
  faArrowDown,
  faCircleQuestion,
  faUserTimes
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import {
  useGetClassesMutation,
  useGetStudentsDetailsByClassesMutation
} from '../../../../features/authentication/authApiSlice';
import {
  useGetClassFilterMutation,
  useUpdateClassFilterMutation
} from '../../../../features/authentication/persistApiSlice';
import { useAssignmentContext } from '../../context';
import AssignmentSettings from '../../../../components/AssignmentSettings';
import {
  useAssignStudentsMutation
} from '../../../../features/authentication/assignApiSlice';
import CustomToast from '../../../../components/Toast';
import ToastTable from '../../../../components/ToastTable';
import moment from 'moment';
import TableSkeleton from '../../../../components/SkeletonLoader/TableSkeleton';
import { useAssessmentContext } from '../../pages/Assessments/AssessmentContext';
import { useGetAssignedStudentsByClassesMutation } from '../../../../features/authentication/studentApiSlice';
import { useChangeModeMutation } from '../../../../features/authentication/assignmentApislice';
import InfiniteScroll from 'react-infinite-scroll-component';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { useChangeAssessmentModeMutation } from '../../../../features/authentication/assessmentApiSlice';

const AssessmentAssignModal = ({ isOpen, onClose, selectedAssessments }) => {
  const [getAllClasses] = useGetClassesMutation();
  const [getClassFilter] = useGetClassFilterMutation();
  const [updateClassFilter] = useUpdateClassFilterMutation();
  const [getUnAssignedStudents] = useGetStudentsDetailsByClassesMutation();
  const [getAssignedStudents] = useGetAssignedStudentsByClassesMutation();
  const [allAssignedData] = useAssignStudentsMutation();
  const [changeMode] = useChangeModeMutation();
  const [changeModeAllStudents] = useChangeAssessmentModeMutation();
  const [selectedClassIds, setSelectedClassIds] = useState([]);
  const [studentsData, setStudentsData] = useState([]);
  const [notAssignedStudents, setNotAssignedStudents] = useState([]);
  const [assignedStudents, setAssignedStudents] = useState([]);
  const [classDetails, setClassDetails] = useState([]);
  const [totalNotAssignedCount, setTotalNotAssignedCount] = useState(0);
  const [totalAssignedCount, setTotalAssignedCount] = useState(0);
  const [toastTable, setToastTable] = useState(false);
  const [assignedResponse, setAssignedResponse] = useState([]);
  const assignmentContext = useAssignmentContext();
  const [isLoading, setIsLoading] = useState(false);
  const [modalTitle, setModalTitle] = useState('Assign Assessment(s) to Students');
  const { setRefreshAssessments } = useAssessmentContext();
  const [activeTab, setActiveTab] = useState(0);
  const [isPersistLoaded, setIsPersistLoaded] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [skipValue, setSkipValue] = useState(0);
  const [isLoadingStudents, setIsLoadingStudents] = useState(false);
  const takeSize = 100;

  const getAllClassesAsync = async () => {
    try {
      const persistIds = await getClassFilter().unwrap();
      let classes = localStorage.getItem('classes');
      if (classes)
        classes = JSON.parse(classes);
      else {
        classes = await getAllClasses().unwrap();
        localStorage.setItem('classes', JSON.stringify(classes));
      }
      setClassDetails(formatClassList(classes, persistIds));
      setSelectedClassIds(persistIds ?? []);
      setIsPersistLoaded(true);
    } catch (error) {
      console.log(error);
    }
  };

  const formatClassList = (classes, persistIds) => {
    return classes.map((item) => ({
      id: item.classID,
      name: item.className,
      description: item.coTeacherClass ? item.teacherName : '',
      isChecked: persistIds?.includes(item.classID) ?? false
    }));
  };

  useEffect(() => {
    getAllClassesAsync();
  }, []);

  useEffect(() => {
    if (!isPersistLoaded) return;

    if (selectedClassIds.length > 0) {
      setSkipValue(0);
      loadStudentsData(0, takeSize);
    } else {
      setStudentsData([]);
      setNotAssignedStudents([]);
      setAssignedStudents([]);
      setTotalCount(0);
      setTotalNotAssignedCount(0);
      setTotalAssignedCount(0);
    }
  }, [selectedClassIds]);

  useEffect(() => {
    if (!isOpen) return;

    const assessmentTitle =
      selectedAssessments?.length === 1
        ? `Assign ${selectedAssessments[0]?.assignmentName} to Students`
        : 'Assign Assessments to Students';

    setModalTitle(assessmentTitle);
  }, [isOpen, selectedAssessments]);

  const loadStudentsData = async (skip, takeSize) => {
    setIsLoading(true);
    var notAssignedResponse = await getAllUnAssignedStudents(skip, takeSize);
    setNotAssignedStudents(notAssignedResponse.data);
    setTotalNotAssignedCount(notAssignedResponse.total);
    if (activeTab == 0) {
      setStudentsData(notAssignedResponse.data);
      setTotalCount(notAssignedResponse.total);
    }

    if (selectedAssessments?.length == 1) {
      var assignedResponse = await getAllAssignedStudents(skip, takeSize);
      setAssignedStudents(assignedResponse.data);
      setTotalAssignedCount(assignedResponse.total);

      if (activeTab == 1) {
        setStudentsData(assignedResponse.data);
        setTotalCount(assignedResponse.total);
      }
    }
    setIsLoading(false);
  };

  const handleClassSelectionChange = (e) => {
    const { key } = e;
    let tempValue = [];

    if (key === '000') {
      const selectAll = classDetails.some((item) => item?.isChecked !== true);
      tempValue = classDetails.map((item) => ({ ...item, isChecked: selectAll }));
    } else {
      const selected = classDetails.find((v) => v.id == key);
      tempValue = classDetails.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }

    setClassDetails(tempValue);
    const ids = tempValue.filter((item) => item?.isChecked === true).map((item) => item.id);
    setSelectedClassIds(ids);
    setClassIdsFilter(ids);
    setSkipValue(0);
  };

  const setClassIdsFilter = async (ids) => {
    try {
      await updateClassFilter(ids).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const getAllUnAssignedStudents = async (skip, takeSize) => {
    try {
      const options = {};
      options.classIds = selectedClassIds;
      options.aIds = selectedAssessments.map((item) => item.assignmentId);
      options.skip = skip;
      options.take = takeSize;
      return await getUnAssignedStudents(options).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const getAllAssignedStudents = async (skip, takeSize) => {
    try {
      const options = {
        assignmentId: selectedAssessments[0]?.assignmentId,
        classIds: selectedClassIds,
        skip: skip,
        take: takeSize
      };
      return await getAssignedStudents(options).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const getStudentKey = (student) => `${student.classId}-${student.studentId}`;

  const handleSelectAll = (isChecked) => {
    let hasDeleted = false;

    let tempStudentsData = studentsData.map((item) => {
      if (!item.deleted) {
        return { ...item, isChecked };
      } else {
        hasDeleted = true;
        return item;
      }
    });

    if (hasDeleted)
      CustomToast('You cannot select Deactivated students', 'warning');

    setStudentsData(tempStudentsData);
  };

  const handleSelect = (key, isChecked) => {
    let tempStudentsData = studentsData.map((item) =>
      getStudentKey(item) === key && !item.deleted ? { ...item, isChecked: isChecked } : item
    );
    setStudentsData(tempStudentsData);
  };

  const resetAssignModal = () => {
    setStudentsData(
      studentsData.map((item) => {
        return { ...item, isChecked: false };
      })
    );
    setSkipValue(0);
  };

  const validateAssignmentData = async (callback) => {
    const timedTimeSpan =
      parseInt(assignmentContext.timedHour * 60) + parseInt(assignmentContext.timedMinute);
    let students = [];

    studentsData
      .filter((item) => item.isChecked === true)
      .map((data) => students.push({ studentId: data.studentId, classId: data.classId }));

    if (assignmentContext.availabilityOption !== 'offline') {
      if (!assignmentContext.assignmentMode) {
        CustomToast('Please select the assignment mode', 'warning');
        return;
      }
    }
    if (assignmentContext.isTimed && timedTimeSpan <= 0) {
      CustomToast('The time length must be greater than 0 minutes.', 'warning');
      return;
    }

    if (assignmentContext.availabilityOption == 'FromTo') {
      const currentDate = moment().format('YYYY/MM/DD h:mm A');
      if (moment(assignmentContext.startDate).isBefore(currentDate, 'day')) {
        CustomToast('From Date must not be before the current day', 'warning');
        return;
      }
      if (moment(assignmentContext.endDate).isBefore(currentDate)) {
        CustomToast('To Date must not be before the current date/time', 'warning');
        return;
      }
      if (moment(assignmentContext.endDate).isBefore(moment(assignmentContext.startDate)) || moment(assignmentContext.endDate).isSame(moment(assignmentContext.startDate))) {
        CustomToast('To Date must be after the From Date', 'warning');
        return;
      }
    }

    if (assignmentContext.retakesEnabled) {
      if (assignmentContext.retakeLimitValue <= 0) {
        CustomToast('You must select a retake limit', 'warning');
        return;
      }
      if (assignmentContext.retakeQuestion === null) {
        CustomToast(
          'You must select an option for Auto Graded Questions to include on Retakes',
          'warning'
        );
        return;
      }
      if (assignmentContext.includeCR === null) {
        CustomToast('You must select an option for CR Questions to include on Retakes', 'warning');
        return;
      }
    }

    let options = {
      assignmentIds: selectedAssessments.map(a => a.assignmentId),
      classIds: selectedClassIds,
      studentIds: students.length == studentsData.length ? [-1] : students.map(student => student.studentId),
      students: students.length == studentsData.length ? selectedClassIds.map((classId) => ({ studentId: -1, classId })) : students,
      selfAssign: false,
      availability: assignmentContext.availabilityOption,
      assignmentMode: assignmentContext.assignmentMode,
      allowAnswerChange: assignmentContext.allowAnswerChange,
      showGrade: assignmentContext.showGrade,
      startDate: assignmentContext.startDate != '' ? moment(assignmentContext.startDate).format('YYYY/MM/DD h:mm A') : '',
      endDate: assignmentContext.endDate != '' ? moment(assignmentContext.endDate).format('YYYY/MM/DD h:mm A') : '',
      studentFileUpload: assignmentContext.studentFileUpload,
      timed: assignmentContext.isTimed,
      timeSpan: timedTimeSpan,
      practice: true,
      assignRetake: assignmentContext.retakesEnabled,
      masteryLevel: assignmentContext.masteryValue,
      retakeMode: assignmentContext.assignmentMode,
      scoreRetries: assignmentContext.scoreRetries,
      retakeLimit: assignmentContext.retakeLimitValue,
      retakeAvailability: assignmentContext.availabilityOption,
      retakeStartDate: assignmentContext.startDate,
      retakeEndDate: assignmentContext.endDate,
      retakeTimed: assignmentContext.isTimed,
      retakeTimeSpan: timedTimeSpan,
      retakeQuestion: assignmentContext.retakeQuestion,
      includeCR: false,
      randomized: assignmentContext.randomized,
      textToSpeech: assignmentContext.textToSpeech,
      autoLockQuestions: assignmentContext.autoLockQuestions,
      allowLangChange: assignmentContext.allowLangChange,
      useCalc: assignmentContext.calculatorEnabled ? 1 : 0,
      useProtractor: assignmentContext.useProtractor ? 1 : 0,
      useRuler: assignmentContext.useRuler ? 1 : 0,
      timeOnTask: assignmentContext.timeOnTaskEnabled,
      period: assignmentContext.timeOnTaskSeconds,
      lockBrowser: assignmentContext.lockBrowser,
      photoMathBlock: assignmentContext.photoMathBlock,
      autoStartCRUponGrading: assignmentContext.autoStartCRUponGrading,
      cranswerToolId: assignmentContext.crAnswerToolType,
      calculatorType: assignmentContext.calculatorType
    };

    callback(options);
  };

  const assignDataHandler = async (assignmentOptions) => {
    try {
      setIsLoading(true);
      const allAssignedDataResponse = await allAssignedData(assignmentOptions).unwrap();

      if (allAssignedDataResponse.length > 0) {
        setToastTable(true);
        setRefreshAssessments(new Date().getSeconds());
        setAssignedResponse(allAssignedDataResponse);
      } else {
        setToastTable(false);
        CustomToast('Error! Couldn\'t Assign', 'error');
      }
      setIsLoading(false);
      resetAssignModal();
    } catch (ex) {
      CustomToast(ex.data, 'error');
      console.log(ex);
      setIsLoading(false);
    }
  };

  const onToastCloseHandler = () => {
    handleOnClose();
    setToastTable(false);
    assignmentContext.setAssignedData([]);
    assignmentContext.setAssignedDataStatus(new Date().getSeconds());
  };

  const handleOnClose = () => {
    onClose();
    resetAssignModal();
  };

  const handleSave = (activeState) => {
    if (activeState == 'Assign')
      validateAssignmentData(assignDataHandler);
    else if (activeState == 'Change Mode') {
      if (studentsData.every(item => item.isChecked) && studentsData.length === totalAssignedCount)
        validateAssignmentData(handleSelectAllChangeMode);
      else
        validateAssignmentData(handleChangeMode);
    }
  };

  const handleChangeMode = async (assignmentOptions) => {
    try {
      setIsLoading(true);
      const changeModeDataResponse = await changeMode({
        assignmentId: selectedAssessments[0]?.assignmentId,
        data: assignmentOptions
      }).unwrap();

      if (changeModeDataResponse > 0) {
        CustomToast(
          `${changeModeDataResponse} student${changeModeDataResponse == 1 ? ' assessment has' : '\'s assessments have'
          } been changed`,
          'success'
        );
        setIsLoading(false);
        handleOnClose();
      } else {
        CustomToast('Error! Couldn\'t change assessment', 'error');
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      CustomToast('Error! Couldn\'t change assessment', 'error');
      setIsLoading(false);
    }
  };

  const handleSelectAllChangeMode = async (assignmentOptions) => {
    try {
      assignmentOptions.assessmentIds = selectedAssessments.map(a => a.assignmentId);
      var response = await changeModeAllStudents(assignmentOptions);
      setIsLoading(true);
      if (response.error) {
        if (response.error.data.errors)
          CustomToast(response.error.data.errors.AssessmentIds, 'error');
        else
          CustomToast(response.error.data.error, 'error');
      } else {
        CustomToast('Change Mode Successfully!', 'success');
        handleOnClose();
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleTabSwitch = (tabId) => {
    setActiveTab(tabId);
    setSkipValue(0);
    if (tabId == 0) {
      setStudentsData(notAssignedStudents);
      setTotalCount(totalNotAssignedCount);
    }
    else if (tabId == 1) {
      setStudentsData(assignedStudents);
      setTotalCount(totalAssignedCount);
    }
  };

  const nextCallback = async (newOffset) => {
    setIsLoadingStudents(true);
    setSkipValue(newOffset);
    if (activeTab == 0) {
      let notAssignedResponse = await getAllUnAssignedStudents(newOffset, takeSize);
      let newItems = [...studentsData, ...notAssignedResponse.data];
      let distinctData = distinctObjects(newItems);
      setStudentsData(distinctData);
    } else if (activeTab == 1) {
      let assignedResponse = await getAllAssignedStudents(newOffset, takeSize);
      let newItems = [...studentsData, ...assignedResponse.data];
      let distinctData = distinctObjects(newItems);
      setStudentsData(distinctData);
    }
    setIsLoadingStudents(false);
  };

  const distinctObjects = (data) => {
    return Array.from(
      data.reduce((map, obj) => map.set(getStudentKey(obj), obj), new Map()).values()
    );
  };

  return (
    <Modal
      contentWidth={'100%'}
      isOpen={isOpen}
      titleName={modalTitle}
      onClose={() => handleOnClose()}>
      <Row>
        <Col className="col-lg-6 p-20 assign-left">
          Class
          <div className="d-flex align-items-center w-60">
            <DropDownSearch
              value={classDetails}
              dropdownId="assessmentAssignClassesFilter"
              placeholder="Filter Classes"
              handleChange={(e) => handleClassSelectionChange(e)}
              selectedId={selectedClassIds}
              description={true}
              selectAllText="All Classes"
              coteacherText={true}
            />
          </div>
          <div className="my-4 gap-2">
            {selectedAssessments?.length == 1 ?
              <div className="d-inline-flex assignStudentsTabs">
                <button className={`btn min-w-150 justify-content-center border-0 ${activeTab == 0 ? 'active' : ''}`} disabled={isLoading} onClick={() => handleTabSwitch(0)}>
                  Not Assigned&nbsp;
                  <span className={activeTab == 0 ? 'activeCount' : 'count'}>{` (${totalNotAssignedCount})`}</span>
                </button>
                <button className={`btn min-w-150 justify-content-center border-0 ${activeTab == 1 ? 'active' : ''}`} disabled={isLoading} onClick={() => handleTabSwitch(1)}>
                  Assigned&nbsp;
                  <span className={activeTab == 1 ? 'activeCount' : 'count'}>{` (${totalAssignedCount})`}</span>
                </button>
              </div>
              :
              <>
                <span className="primary-title">Not Assigned</span> ({totalNotAssignedCount}){' '}
                <OverlayTrigger
                  key="tooltip-notAssigned"
                  placement="top"
                  overlay={
                    <Tooltip id="not-assigned-info" className="not-assigned-tooltip">
                      <p>
                        The following students are in the class, but you have NOT assigned these
                        assignments to them. To add students to the assignments, check the box next
                        to the names and click ASSIGN.
                      </p>
                    </Tooltip>
                  }>
                  <FontAwesomeIcon className="circle-question" icon={faCircleQuestion} />
                </OverlayTrigger>
              </>
            }
          </div>
          {isLoading ? (
            <TableSkeleton
              rowCount={8}
              colCount={3}
              tableClass={'pt-4'}
              skeletonClass={'pt-2'} />
          ) : (
            <InfiniteScroll
              dataLength={studentsData.length}
              next={() => nextCallback(skipValue + takeSize)}
              hasMore={skipValue + takeSize < totalCount}
              scrollableTarget='scrollableTable'>
              <div id='scrollableTable' className="assignments-scroll-bar custom-table table-responsive not-assigned-table transparent-scroll" style={{ height: '520px', overflowY: 'auto' }}>
                <table className="table reportTable">
                  <thead>
                    <tr>
                      <th className='w-10'>
                        <div className="form-check">
                          {studentsData.length > 0 && 
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="assignCheck"
                              name="assignCheck"
                              checked={studentsData.filter((item) => item?.isChecked !== true).length < 1}
                              onChange={(e) => handleSelectAll(e.target.checked, activeTab)}
                            />
                          }
                        </div>
                      </th>
                      <th>Last Name</th>
                      <th>First Name</th>
                    </tr>
                  </thead>
                  <tbody id="list-body">
                    {isLoading === false && (
                      <>
                        {studentsData.length > 0 ? (
                          <>
                            {studentsData.map((item, index) => (
                              <tr key={`${getStudentKey(item)}-${index}`}>
                                <td>
                                  {!item.deleted && (
                                    <div className="form-check">
                                      <input
                                        type="checkbox"
                                        name={getStudentKey(item)}
                                        checked={item?.isChecked}
                                        onChange={(e) => handleSelect(getStudentKey(item), e.target.checked)}
                                        className="form-check-input"
                                        id={`flexCheckDefault-${getStudentKey(item)}`}
                                      />
                                    </div>
                                  )}
                                  {item.deleted && (
                                    <OverlayTrigger
                                      placement="right"
                                      overlay={
                                        <Tooltip className="tooltip-white">
                                          <h4>Deactivated</h4>
                                          <p className="mb-0">
                                            Students cannot use deactivated accounts, but teacher
                                            and administrator reports do include data for these
                                            accounts{' '}
                                          </p>
                                        </Tooltip>
                                      }>
                                      <div className="deactivated">
                                        <FontAwesomeIcon icon={faUserTimes} />
                                      </div>
                                    </OverlayTrigger>
                                  )}
                                </td>
                                <td className={item.deleted ? 'disable-data' : ''}>
                                  {item.lName}
                                </td>
                                <td className={item.deleted ? 'disable-data' : ''}>
                                  {item.fName}
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr>
                            <td colSpan={3} className="fs-6 text-center">
                              {activeTab == 0 ? 'There is no more unassigned student in this class' : 'There is no student in this class'}
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
                {isLoadingStudents &&
                  <div className='mt-3 text-center fs-4'>
                    <FontAwesomeIcon icon={faSpinner} spin /><span className='ms-2'></span>
                  </div>
                }
              </div>
            </InfiniteScroll>
          )}
        </Col>
        <Col>
          <AssignmentSettings
            allowRetakesOption={false}
            headingDescription={true}
            availabilityRequired={true}
            modesRequired={true}
            showBetaButton={true}
            noColumn={true}
            randomizedQuestion={true}
            disabledTextSpeach={true}
            allowOfflineMode={true}
            isSelfAssign={false}
            isAssessment={true}
          />
        </Col>
      </Row>
      <div className="scrolldown-btn">
        <span>Scroll Down</span>
        <FontAwesomeIcon icon={faArrowDown} />
      </div>
      <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
        <button
          className="btn btn-castleGray btn-width"
          onClick={() => handleOnClose()}>
          Cancel
        </button>

        <button
          name={`${activeTab === 0 ? 'Assign' : 'Change Mode'}`}
          className="btn btn-castleRed min-w-150"
          onClick={(e) => handleSave(e.target.name)}
          disabled={isLoading || !studentsData.some(item => item?.isChecked)}>
          {`${activeTab === 0 ? 'Assign' : 'Change Mode'}`}
        </button>
      </div>

      {toastTable && <ToastTable data={assignedResponse} onClose={onToastCloseHandler}  title={'Assessment'}/>}
    </Modal>
  );
};

AssessmentAssignModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  selectedAssessments: PropTypes.array
};

export default AssessmentAssignModal;
